import Vue from 'vue'
import Router from 'vue-router'

import RouterByl from './router-byl'
import RouterHoneywell from './router-entrain'
import RouterPartyTraining from './router-partyTraining'
import RouterContinueEdu from './router-continueEdu'

Vue.use(Router)

const allRouterArr = []
const routesBylList = RouterByl.routes
const routesHoneywellList = RouterHoneywell.routes
const routesPartyTrainingList = RouterPartyTraining.routes
const routesContinueEduList = RouterContinueEdu.routes

const routersList = allRouterArr.concat(routesBylList, routesHoneywellList, routesPartyTrainingList, routesContinueEduList)
export default new Router({
  mode: 'history',
  routes: routersList
})



// WEBPACK FOOTER //
// ./src/router/index.js